import React, { useState } from "react"
import { Box, Grid, Paper, Typography, Stack, TextField, InputAdornment } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import CategoryIcon from "@mui/icons-material/Category"
import { useTranslation } from "react-i18next"
import { useVisualEditor } from "../VisualEditorContext"
import DraggableSection from "./DraggableSection"
import DroppableCanvas from "./DroppableCanvas"

const SectionsTab = () => {
  const { t } = useTranslation()
  const { types } = useVisualEditor()
  const [search, setSearch] = useState("")

  const filteredTypes = types.filter((type) =>
    type.name?.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <Grid container spacing={2}>
      {/* Left Panel - Drop Zone (70%) */}
      <Grid item xs={12} md={8}>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            borderRadius: 3,
            border: "1px solid #e2e8f0",
            minHeight: 500,
          }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
            <CategoryIcon sx={{ color: "#3b82f6" }} />
            <Typography variant="subtitle1" fontWeight={600} color="#1e293b">
              {t("Production Steps")}
            </Typography>
          </Stack>

          <DroppableCanvas />
        </Paper>
      </Grid>

      {/* Right Panel - Sections Palette (30%) */}
      <Grid item xs={12} md={4}>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            borderRadius: 3,
            border: "1px solid #e2e8f0",
            position: "sticky",
            top: 80,
          }}
        >
          <Typography variant="subtitle1" fontWeight={600} color="#1e293b" sx={{ mb: 2 }}>
            {t("Available Sections")}
          </Typography>

          <TextField
            fullWidth
            size="small"
            placeholder={t("Search sections...")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#94a3b8", fontSize: 20 }} />
                </InputAdornment>
              ),
            }}
          />

          <Typography variant="caption" color="#64748b" sx={{ mb: 1.5, display: "block" }}>
            {t("Drag sections to the left panel to create steps")}
          </Typography>

          <Stack spacing={1}>
            {filteredTypes.map((type, index) => (
              <DraggableSection key={index} section={type} />
            ))}

            {filteredTypes.length === 0 && (
              <Box sx={{ textAlign: "center", py: 4, color: "#94a3b8" }}>
                <Typography variant="body2">
                  {types.length === 0 ? t("No sections available") : t("No matching sections")}
                </Typography>
              </Box>
            )}
          </Stack>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default SectionsTab
